// CRO Hero — Storefront event capture module
// Vanilla JS, injected via Shopify App Block. No external dependencies.
(function () {
  'use strict';

  var config = window.CROHero || {};
  if (!config.storeId || !config.endpoint) return;

  // --- Session & Device ---

  var SESSION_KEY = 'crohero_sid';
  var sessionId = (function () {
    var stored = sessionStorage.getItem(SESSION_KEY);
    if (stored) return stored;
    var id = typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID()
      : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = (Math.random() * 16) | 0;
          return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
        });
    sessionStorage.setItem(SESSION_KEY, id);
    return id;
  })();

  var deviceType = /Mobi|Android/i.test(navigator.userAgent) ? 'mobile' : 'desktop';
  var viewportWidth = window.innerWidth;
  var referralSource = document.referrer || null;
  var pageLoadTime = Date.now();

  // --- Event Queue ---

  var queue = [];
  var FLUSH_INTERVAL = 5000;

  function enqueue(type, data) {
    var evt = {
      store_id: config.storeId,
      session_id: sessionId,
      event_type: type,
      page_url: location.href,
      device_type: deviceType,
      viewport_width: viewportWidth,
      referral_source: referralSource,
      created_at: new Date().toISOString()
    };
    if (data) {
      for (var k in data) {
        if (data.hasOwnProperty(k)) evt[k] = data[k];
      }
    }
    queue.push(evt);
    if (queue.length >= 10) flush();
  }

  function flush() {
    if (!queue.length) return;
    var batch = queue.splice(0);
    var body = JSON.stringify({ events: batch });
    var xhr = new XMLHttpRequest();
    xhr.open('POST', config.endpoint, true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(body);
  }

  var flushTimer = setInterval(flush, FLUSH_INTERVAL);

  // --- Helpers ---

  function elMeta(el) {
    if (!el || !el.tagName) return {};
    return {
      element_tag: el.tagName.toLowerCase(),
      element_id: el.id || null,
      element_class: el.className && typeof el.className === 'string'
        ? el.className.slice(0, 200)
        : null
    };
  }

  // --- Click / Tap Tracking ---

  var rageState = { el: null, count: 0, timer: null };

  function isSameElement(a, b) {
    return a === b;
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    var data = elMeta(target);
    data.x = e.clientX;
    data.y = e.clientY;
    enqueue('click', data);

    // Rage click detection: 3+ clicks on the same element within 2s
    if (isSameElement(target, rageState.el)) {
      rageState.count++;
    } else {
      rageState.el = target;
      rageState.count = 1;
      clearTimeout(rageState.timer);
    }
    clearTimeout(rageState.timer);
    rageState.timer = setTimeout(function () {
      rageState.el = null;
      rageState.count = 0;
    }, 2000);

    if (rageState.count >= 3) {
      enqueue('rage_click', elMeta(target));
      rageState.count = 0; // reset so we don't fire continuously
    }
  }, true);

  // --- ATC Tracking (theme-agnostic: intercept /cart/add requests) ---

  var CART_ADD_RE = /\/cart\/add/;

  // 1. Monkey-patch fetch to intercept POST /cart/add.js
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url ? input.url : '');
      var method = (init && init.method ? init.method : 'GET').toUpperCase();
      if (method === 'POST' && CART_ADD_RE.test(url)) {
        enqueue('atc_fire', { element_tag: 'fetch', element_id: url });
        return origFetch.apply(this, arguments).then(function (response) {
          if (response.ok) {
            enqueue('atc_success', { element_tag: 'fetch', element_id: url });
          } else {
            enqueue('atc_fail', { element_tag: 'fetch', element_id: url });
          }
          return response;
        }, function (err) {
          enqueue('atc_fail', { element_tag: 'fetch', element_id: url });
          throw err;
        });
      }
      return origFetch.apply(this, arguments);
    };
  }

  // 2. Monkey-patch XMLHttpRequest to intercept POST /cart/add.js
  var origXhrOpen = XMLHttpRequest.prototype.open;
  var origXhrSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._crohero_method = method;
    this._crohero_url = url;
    return origXhrOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (
      xhr._crohero_method &&
      xhr._crohero_method.toUpperCase() === 'POST' &&
      CART_ADD_RE.test(xhr._crohero_url || '')
    ) {
      var xhrUrl = xhr._crohero_url;
      enqueue('atc_fire', { element_tag: 'xhr', element_id: xhrUrl });
      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          enqueue('atc_success', { element_tag: 'xhr', element_id: xhrUrl });
        } else {
          enqueue('atc_fail', { element_tag: 'xhr', element_id: xhrUrl });
        }
      });
      xhr.addEventListener('error', function () {
        enqueue('atc_fail', { element_tag: 'xhr', element_id: xhrUrl });
      });
    }
    return origXhrSend.apply(this, arguments);
  };

  // 3. Intercept form[action="/cart/add"] submits (fallback for non-AJAX themes)
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.tagName || form.tagName.toLowerCase() !== 'form') return;
    var action = form.getAttribute('action') || '';
    if (CART_ADD_RE.test(action)) {
      enqueue('atc_fire', { element_tag: 'form_submit', element_id: action });
      // For non-AJAX submits the page will navigate, so we can't track success/fail.
      // The atc_fire event alone is still valuable.
    }
  }, true);

  // 4. Listen for Shopify global cart events (fired by some themes after AJAX add)
  document.addEventListener('cart:added', function () {
    enqueue('atc_success', { element_tag: 'shopify_event', element_id: 'cart:added' });
  });
  document.addEventListener('cart:item-added', function () {
    enqueue('atc_success', { element_tag: 'shopify_event', element_id: 'cart:item-added' });
  });

  // --- Scroll Depth Tracking ---

  var scrollThresholds = { 25: false, 50: false, 75: false, 100: false };
  var currentMaxScroll = 0;

  function getScrollPct() {
    var docHeight = Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight
    );
    var winHeight = window.innerHeight;
    if (docHeight <= winHeight) return 100;
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return Math.min(100, Math.round((scrollTop / (docHeight - winHeight)) * 100));
  }

  function checkScrollThresholds() {
    var pct = getScrollPct();
    if (pct > currentMaxScroll) currentMaxScroll = pct;
    var marks = [25, 50, 75, 100];
    for (var i = 0; i < marks.length; i++) {
      var m = marks[i];
      if (!scrollThresholds[m] && pct >= m) {
        scrollThresholds[m] = true;
        enqueue('scroll', { scroll_pct: m });
      }
    }
  }

  function resetScrollState() {
    scrollThresholds = { 25: false, 50: false, 75: false, 100: false };
    currentMaxScroll = 0;
  }

  var scrollRaf = false;
  window.addEventListener('scroll', function () {
    if (scrollRaf) return;
    scrollRaf = true;
    requestAnimationFrame(function () {
      scrollRaf = false;
      checkScrollThresholds();
    });
  }, { passive: true });

  // Fire an initial scroll check after the page renders.
  // Catches short pages that fit in the viewport (100% scroll with no scroll event).
  // Uses a delay so the DOM has time to reach full height (lazy-loaded images, etc.).
  setTimeout(checkScrollThresholds, 1500);

  // --- Form Focus / Blur Tracking ---

  var formFieldValues = {};

  document.addEventListener('focus', function (e) {
    var el = e.target;
    if (!isFormField(el)) return;
    var name = fieldName(el);
    formFieldValues[name] = el.value || '';
    enqueue('form_focus', { element_tag: el.tagName.toLowerCase(), element_id: name });
  }, true);

  document.addEventListener('blur', function (e) {
    var el = e.target;
    if (!isFormField(el)) return;
    var name = fieldName(el);
    var abandoned = (el.value || '') === (formFieldValues[name] || '');
    enqueue('form_blur', {
      element_tag: el.tagName.toLowerCase(),
      element_id: name,
      abandoned: abandoned
    });
    delete formFieldValues[name];
  }, true);

  function isFormField(el) {
    if (!el || !el.tagName) return false;
    var tag = el.tagName.toLowerCase();
    return tag === 'input' || tag === 'textarea' || tag === 'select';
  }

  function fieldName(el) {
    return el.name || el.id || el.getAttribute('aria-label') || el.type || 'unknown';
  }

  // --- JS Error Tracking ---

  window.onerror = function (message, source, lineno, colno, error) {
    var stack = '';
    if (error && error.stack) {
      stack = error.stack.slice(0, 200);
    }
    enqueue('js_error', {
      error_message: String(message).slice(0, 500),
      element_id: stack // reusing element_id field for stack per schema
    });
  };

  // --- Page Exit ---

  window.addEventListener('beforeunload', function () {
    enqueue('page_exit', {
      scroll_pct: currentMaxScroll,
      time_on_page: Math.round((Date.now() - pageLoadTime) / 1000)
    });
    flush();
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') flush();
  });

  // --- SPA Navigation (Shopify themes with AJAX nav / History API) ---

  // Reset scroll thresholds and page state when the URL changes without a full reload.
  var lastUrl = location.href;
  function onSpaNavigation() {
    if (location.href === lastUrl) return;
    // Fire exit for the old page
    enqueue('page_exit', {
      scroll_pct: currentMaxScroll,
      time_on_page: Math.round((Date.now() - pageLoadTime) / 1000)
    });
    flush();
    // Reset state for the new page
    lastUrl = location.href;
    pageLoadTime = Date.now();
    resetScrollState();
    referralSource = document.referrer || null;
    // Check scroll after new content renders
    setTimeout(checkScrollThresholds, 1500);
  }

  // Listen for History API navigation (pushState / popstate)
  var origPushState = history.pushState;
  history.pushState = function () {
    origPushState.apply(this, arguments);
    onSpaNavigation();
  };
  var origReplaceState = history.replaceState;
  history.replaceState = function () {
    origReplaceState.apply(this, arguments);
    onSpaNavigation();
  };
  window.addEventListener('popstate', onSpaNavigation);

  window.addEventListener('pagehide', function () {
    clearInterval(flushTimer);
  });
})();
